// third-party
import { useSearchParams } from 'react-router-dom';
import { logError } from 'utils/monitoring';

// project import
import AuthWrapper from 'sections/auth/AuthWrapper';
import AuthCodeVerification from 'sections/auth/auth-forms/AuthCodeVerification';
import { errorAlert, successAlert } from 'utils/alert';
import { t } from 'utils/getTranslations';

// Hooks
import useAuth from 'hooks/useAuth';

// ================================|| CODE VERIFICATION ||================================ //

const CodeVerification = () => {
    const [searchParams] = useSearchParams();
    const { sendResetPasswordCode } = useAuth();

    const missingEmailError = () => {
        errorAlert(t('auth.could-not-find-email-go-to-forgot-pw-page'));
    };

    const getEmailFromUrl = () => {
        const email = searchParams.get('to');
        return email ? decodeURIComponent(email) : null;
    };

    const onSendResetCode = () => {
        const email = getEmailFromUrl();
        if (!email) {
            missingEmailError();
            logError(new Error('Error sending password reset code, no email address found'));
        } else {
            sendResetPasswordCode(email).then(
                () => {
                    successAlert(t('auth.password-reset-potentially-sent'));
                },
                (err: unknown) => {
                    errorAlert(t('auth.error-sending-reset-code'));
                    logError(err);
                }
            );
        }
    };

    return (
        <AuthWrapper>
            <div className="flex flex-col gap-6">
                <div className="flex flex-col gap-2">
                    <h3 className="text-h3 text-balance">{t('auth.enter-verification-code')}</h3>
                    {searchParams.get('to') && (
                        <p className="text-body1 text-fg-secondary">
                            {t('auth.code-sent-to-email', { email: getEmailFromUrl() || '' })}
                        </p>
                    )}
                </div>
                <AuthCodeVerification
                    onSendResetCode={onSendResetCode}
                    email={getEmailFromUrl()}
                    missingEmailError={missingEmailError}
                />
            </div>
        </AuthWrapper>
    );
};

export default CodeVerification;
